import { render } from "./InvoiceHome.vue?vue&type=template&id=bc7c0928"
import script from "./InvoiceHome.vue?vue&type=script&lang=js"
export * from "./InvoiceHome.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__